import { PublicSettings } from '@witkac/kartamiejska-shared';
import { RouteConfig } from 'vue-router';

import { LocalStorage } from '@/enums/storage.enum';
import store from '@/store';

export const profileConfigRoute: RouteConfig = {
  path: '/profile',
  component: () => import(/* webpackChunkName: "Profile" */ '@/views/main/settings/Profile.vue'),
  name: 'profileConfig',
  beforeEnter(to, from, next) {
    store.commit('profile/setId', localStorage.getItem(LocalStorage.USER_ID));

    Promise.all([
      store.dispatch('card/list'),
      store.dispatch('settings/get', PublicSettings.PROFILE_EDITABLE_PROPERTIES)
    ])
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać profilu.' }));
  }
};
